import countryContactsData from 'config/countryContacts.json';

interface ContactDetails {
  email: string;
  phone: string;
}

// Type the imported JSON data
type CountryContactsData = Record<string, { email: string; phone: string }>;
const contacts = countryContactsData as CountryContactsData;

// Map JSON data to match the existing structure
const contactEmail = [
  {
    country: 'ROU',
    postal: 'ro',
    email: contacts.Romania.email,
    phone: contacts.Romania.phone,
  },
  {
    country: 'POL',
    postal: 'pl',
    email: contacts.Poland.email,
    phone: contacts.Poland.phone,
  },
  {
    country: 'HUN',
    postal: 'hu',
    email: contacts.Hungary.email,
    phone: contacts.Hungary.phone,
  },
  {
    country: 'BGR',
    postal: 'bg',
    email: contacts.Bulgaria.email,
    phone: contacts.Bulgaria.phone,
  },
  {
    country: 'DEU',
    postal: 'de',
    email: contacts.Germany.email,
    phone: contacts.Germany.phone,
  },
  {
    country: 'GBR',
    postal: 'gb',
    email: contacts['United Kingdom'].email,
    phone: contacts['United Kingdom'].phone,
  },
  {
    country: 'SRB',
    postal: 'rs',
    email: contacts.Serbia.email,
    phone: contacts.Serbia.phone,
  },
  {
    country: 'ESP',
    postal: 'es',
    email: contacts.Spain.email,
    phone: contacts.Spain.phone,
  },
  {
    country: 'UKR',
    postal: 'ua',
    langCode: 'uk',
    email: 'syngenta.ua@syngenta.com',
    phone: '+38 (044) 494 17 71',
  },
  {
    country: 'ZAF',
    postal: 'za',
    email: 'https://sensako.co.za/Sales',
    phone: '',
  },
];

const nonDDGContactEmail = [
  {
    country: 'ROU',
    postal: 'ro',
    email: 'Servicii.Online@syngenta.com',
    phone: '0745973337',
  },
  {
    country: 'POL',
    postal: 'pl',
    email: 'marta.cywinska@syngenta.com / joanna.tarkowska@syngenta.com',
    phone: '+48 602 769 296  / +48-785 241 721',
  },
  {
    country: 'BGR',
    postal: 'bg',
    email: 'bulgaria.office@syngenta.com',
    phone: '+359882735800',
  },
];

const DUMMY_MAIL = 'contact@syngenta.com';
const DUMMY_PHONE_NUMBER = '01223 883400';
const langCode = localStorage.getItem('i18nextLng');

const findContact = (countryCode: string | null): ContactDetails => {
  const contact = contactEmail.find(
    (data) =>
      data.country.toLocaleLowerCase() === countryCode?.toLocaleLowerCase() ||
      data.postal.toLocaleLowerCase() === countryCode?.toLocaleLowerCase() ||
      data.langCode?.toLocaleLowerCase() === langCode
  );
  return contact
    ? { email: contact.email, phone: contact.phone }
    : { email: DUMMY_MAIL, phone: DUMMY_PHONE_NUMBER };
};

const findNonDDGContact = (countryCode: string | null): ContactDetails => {
  const contact = nonDDGContactEmail.find(
    (data) =>
      data.country.toLocaleLowerCase() === countryCode?.toLocaleLowerCase() ||
      data.postal.toLocaleLowerCase() === countryCode?.toLocaleLowerCase()
  );
  return contact
    ? { email: contact.email, phone: contact.phone }
    : { email: DUMMY_MAIL, phone: DUMMY_PHONE_NUMBER };
};

export const getContactDetails = (countryCode: string, isDDG?: boolean): ContactDetails => {
  if (isDDG) {
    return findContact(countryCode);
  } else {
    return findNonDDGContact(countryCode);
  }
};

export const getEmailId = (countryCode: string | null): string => {
  if (countryCode === null) {
    return DUMMY_MAIL;
  }
  return getContactDetails(countryCode).email;
};
